import React from 'react'
import ClientListPresenter from './ClientListPresenter'
import { dialog, Button } from '../../../nq-component'
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from '../../../usecases/schema/usecases'
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from '../../../usecases/object'
import { exportCSVUseCase } from '../../../usecases/csv/usecases'
import { Progress, InfiniteScroll } from '../../../nq-component'
import withRouter from '../../../withRouter'
import Search from './../components/Search'
import BaseListPage from '../../../base/BaseListPage'
import NavBar from '../../../components/navbar'
import InputFactory from '../../../components/InputFactory'
import Table from '../../../components/Table'


class ClientListPage extends BaseListPage {
  constructor(props) {
    super(props)
    this.presenter = new ClientListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    )
  }

  /*when class change*/
  componentDidUpdate(prevProps, prevState) {
    this.presenter.componentDidUpdate(prevProps, prevState)
  }

  getCollectionName() {
    return "client";
  }

  closeDialog() {
    dialog.close()
  }

  onClickAdd() {
    this.navigateTo(`/client/form`)
  }

  onClickEdit(index) {
    const object = this.state.objects[index];
    this.navigateTo(`/client/form/${object?.id}`);
  }

  onClickView(index) {
    const object = this.state.objects[index];
    this.navigateTo(`/client/view/${object?.id}`)
  }

  onChangeFilter(type, value, field) {
    const where = {}
    switch (type) {
      case 'Pointer':
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id }
        }
        break
      case 'Boolean':
        where[field] = value
        break
      default:
        where[field] = { $regex: value, $options: 'i' }
    }
    this.searchSubmit(where)
  }

  toggleStatus(index) {
    const object = this.state.objects[index]
    this.presenter.handleStatus(object)
  }

  renderStatusButtons(index) {
    const object = this.state.objects[index]
    const isActive = object.status === 'Active'

    return (
      <button
        className={isActive ? 'btn btn-warning' : 'btn btn-success'}
        onClick={() => this.toggleStatus(index)}>
          <i className={isActive ? 'bi bi-person-dash' : 'bi bi-person-check'}/> {isActive ? ' Inactive' : ' Active'}
      </button>
    )
  }

  acceptApplication(index, field) {
    this.presenter.acceptApplication(index, field)
  }

  handleDelete(index){
    const object = this.state.objects[index]
    this.presenter.handleDelete(object)
  }

  onCollapse(index) {
    const data = this.state.objects[index];
  
    return (
      <div className='p-1 text-start'>
        <div><strong>First Name:</strong> {data?.first_name}</div>
        <div><strong>Last Name:</strong> {data?.last_name}</div>
        <div><strong>Address:</strong> {data?.address}</div>
        <div><strong>Contact:</strong> {data?.contact_number}</div>
        <div><strong>Email Address:</strong> {data?.email_address}</div>
        
        <div className="mt-2 d-flex align-items-center gap-2">
          {/* <button
            className="btn btn-danger"
            onClick={() => this.handleDelete(index)}
          >
            <i className="bi bi-person-dash" /> Delete
          </button> */}
  
          <button
            className="btn btn-primary"
            onClick={() => this.onClickView(index)}
          >
            <i className="bi bi-eye" /> View
          </button>

          {this.renderStatusButtons(index)}
  
          <div className="dropdown">
            <i
              className="bi bi-three-dots-vertical"
              role="button"
              id={`dropdownMenuButton-${index}`}
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ fontSize: '1.2rem', cursor: 'pointer' }}
            />

            <div
              className="dropdown-menu p-2"
              aria-labelledby={`dropdownMenuButton-${index}`}
              style={{ minWidth: '86px', width: 'fit-content' }}
            >
              <button
                className="btn btn-primary"
                onClick={() => this.onClickEdit(index)}
              >
                <i className="bi bi-pen-fill" /> Edit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }  

  render() {
    const schema = this.getSchema(this.getCollectionName())
    const { objects, count, progress } = this.state
    
    if (!schema) return <Progress />
    const user = this.getCurrentUser()
    return (
      <>
        <NavBar 
          action={() => {
            if(!user.isMaster) return null
            return (
              <div className='dropdown dropstart d-inline-block'>
                <i
                  data-bs-toggle='dropdown'
                  className='bi bi-three-dots-vertical text-primary'
                ></i>
              </div>
            )
          }}/>
        <div className='overflow-auto'>
          <InfiniteScroll
            className='h-100'
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className='p-3 p-lg-4'>
              <div className='d-flex justify-content-between align-items-center'>
                <h1 className='fw-bold text-capitalize'>
                  {schema.label || this.getCollectionName()}s
                </h1>
              </div>
              <div className='d-flex mt-3'>
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field]
                  return (
                    <InputFactory
                      key={field}
                      className='ms-1'
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  )
                })}
              </div>
              <Search
                schemas={this.getSchemas()}
                className='mt-3'
                onSubmit={this.searchSubmit.bind(this)}
                fields={schema.fields}
              />
              <Table
                fields={schema.fields}
                objects={objects}
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key]
                    if (options.read === false) {
                      acc.push(key)
                    }
                    switch (options._type || options.type) {
                      case 'Relation':
                      case 'Array':
                      case 'Object':
                      case 'File':
                        acc.push(key)
                        break
                      default:
                    }
                    return acc
                  },
                  ['acl', 'password', 'address', 'contact_number', 'email_address', 'first_name', 'last_name', 'id']
                )}
                progress={progress}
                onClickItem={this.onClickItem.bind(this)}
                className='mt-3 rounded text-center'
                onCollapse={this.onCollapse.bind(this)}           
              />
            </div>
          </InfiniteScroll>
        </div>
        <div className='position-fixed bottom-0 end-0 m-4'>
          <Button
            className='btn btn-primary shadow-sm bg-primary'
            onClick={this.onClickAdd.bind(this)}
            style={{ width: '50px', height: '50px', borderRadius: '25px' }}
          >
            <i className='bi bi-plus-lg' />
          </Button>
        </div>
      </>
    )
  }
}

export default withRouter(ClientListPage)